import { t } from '@lingui/core/macro';
import { AgenticLoader, Box, LoaderOverlay } from '@pocketlaw/tetris';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { useWorkflowCheck } from 'app/domains/workflows/features/WorkflowCheckProvider';
import { useAutoRunWorkflow } from 'app/domains/workflows/features/useAutoRunWorkflow';
import { ReviewState } from './ReviewState';
import { WorkflowApproversProvider } from './WorkflowApproversProvider';
import { WorkflowInitialState } from './WorkflowInitialState';
import { RequestVoluntary } from '../RequestVoluntary';
export function RequestVoluntaryAdvanced() {
    const { startCheck, state, approvalResult, approvalWorkflows } = useWorkflowCheck();
    const { isFeatureAvailable } = useCompanyFeatures();
    const isWorkflowsAvailable = isFeatureAvailable('DOCUMENT_ASSISTANT_WORKFLOWS');
    const handleSelectWorkflow = (workflowId) => {
        startCheck(workflowId);
    };
    const evaluatingLabels = [
        t({ comment: 'Running approval rules check loading message', message: 'Checking rules...' }),
        t({ comment: 'Running approval rules check loading message', message: 'Evaluating rules...' }),
        t({ comment: 'Running approval rules check loading message', message: 'Applying rules...' }),
    ];
    useAutoRunWorkflow();
    if (state === 'loading') {
        return (<Box height="100%">
        <LoaderOverlay label={t({
                comment: 'Approval sidebar - Loading approvers label',
                message: 'Loading approvers...',
            })}/>
      </Box>);
    }
    if (!isWorkflowsAvailable || approvalWorkflows.length === 0) {
        return <RequestVoluntary />;
    }
    return (<AgenticLoader loading={state === 'evaluating'} loadingLabels={evaluatingLabels}>
      <WorkflowApproversProvider>
        {approvalResult.isChecked && <ReviewState />}

        {!approvalResult.isChecked && (<WorkflowInitialState workflows={approvalWorkflows} onSelectWorkflow={handleSelectWorkflow}/>)}
      </WorkflowApproversProvider>
    </AgenticLoader>);
}
